import axios from 'axios'
import Environments from '../environments/Environment';

var http = null;


class APIProvider {
    constructor() {
        http = axios.create({
            baseURL: Environments.WTS_URL,
            headers: { 'Content-Type': 'application/json' },
        });
    }

    sendWhatsapp(data) {
        return new Promise((success, error) => {
            http.post('/send', data).then((result) => {
                success(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
                // console.log(error.config);
            });
        });
    }

}

export default new APIProvider();


// WEBPACK FOOTER //
// ./src/services/SendWhatsapp.js